import { DragEvent } from 'react';
import { Bars2Icon } from '@heroicons/react/24/outline';

export function moveItem<T extends { id: string }>(items: T[], fromId: string, toId: string): T[] {
  const from = items.findIndex((item) => item.id === fromId);
  const to = items.findIndex((item) => item.id === toId);
  if (from < 0 || to < 0 || from === to) return items;
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}

export function ReorderHandle({
  label,
  onDragStart,
  onDragEnd,
}: {
  label: string;
  onDragStart: (event: DragEvent<HTMLSpanElement>) => void;
  onDragEnd: () => void;
}) {
  return (
    <span
      role="button"
      tabIndex={0}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      className="flex min-h-[44px] min-w-[44px] items-center justify-center text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing"
      aria-label={label}
    >
      <Bars2Icon className="h-5 w-5" />
    </span>
  );
}
